var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"shipment-detail-status"},[_c('shipment-detail-reference'),_c('shipment-detail-status-map'),_c('shipment-summary'),_c('shipment-detail-status-content'),(_vm.hasRate)?_c('shipment-rate'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }